import React, { useState, useEffect, useMemo } from "react";
import ObjectForm from "../../Common/ObjectForm";
import http from "../../Common/RestAPIHandler";
import countryCodes from "../../Common/CountryCodes";
import ScreenLoader from "../../Common/Loader";
import { pUser } from "../../Common/Languages";

const PortalUserForm = (props) => {
  const [roles, setRoles] = useState([]);
  const [formFields, setFormFields] = useState();
  const [loadData, setLoadData] = useState(false);

  const lang = localStorage.getItem("languages");

  const countryCodeMap = useMemo(() => {
    const map = {};
    Object.keys(countryCodes).forEach(function (c) {
      if (!map[countryCodes[c].code]) {
        map[countryCodes[c].code] = countryCodes[c].name;
      } else {
        map[countryCodes[c].code] =
          map[countryCodes[c].code] + " / " + countryCodes[c].name;
      }
    });
    return map;
  }, []);

  useEffect(() => {
    setLoadData(true);
    http.Get(
      `portal-roles`,
      (data) => {
        const map = {
          '-1': 'NONE'
        };
        data = data.filter((role) => role.status === true);
        for (let i = 0; i < data.length; i++) {
          map[data[i].id] = data[i].role_name;
        }
        setRoles(map);
        setLoadData(false);
      },
      () => {}
    );
  }, []);

  useEffect(() => {
    setFormFields([
      {
        id: "company_name",
        label: pUser.COMPANY[lang],
        type: "readonly",
      },
      {
        id: "employee_name",
        label: pUser.EMPLOYEENAME[lang],
        type: "readonly",
      },
      {
        id: "email",
        label: pUser.EMAIL[lang],
        type: "readonly",
      },
      {
        id: "mobile",
        label: pUser.MOBILE[lang],
        type: "text",
      },
      {
        id: "country_code",
        label: pUser.COUNTRYCODE[lang],
        type: "select",
        valueMap: countryCodeMap,
      },
      {
        id: "is_hidden",
        label: pUser.HIDDEN[lang],
        type: "radio",
      },
      {
        id: "is_billing_contact",
        label: pUser.BILLINGCONTACT[lang],
        type: "radio",
      },
      {
        id: "role_id",
        label: pUser.PORTALROLE[lang],
        type: "select",
        valueMap: roles,
        onChange: (e, object, setObject) => {
          setObject({
            ...object,
            [e.target.name]: e.target.value !== '-1' ? e.target.value : null,
          });
        },
      },
    ]);
  }, [roles, countryCodeMap, lang]);

  return (
    <div>
      {loadData && <ScreenLoader/>}
      {formFields && (
        <ObjectForm
          {...props}
          url={`company_employees`}
          formName={pUser.PortalUser[lang]}
          formFields={formFields}
        />
      )}
    </div>
  );
};

export default PortalUserForm;
